<template>
  <div class="my-header">
    <div class="container">
      <div class="logo">
        <img src="../assets/img/logo.png" alt="">
      </div>
      <div class="nav-menu">
        <router-link class="menu-item" :to="{ name: 'Home' }" :class="{ active: activeId == 0 }">
          首页
        </router-link>
        <router-link
          class="menu-item"
          :class="{ active: activeId == m.id }"
          :to="{ name: 'Films', params: { id: m.id } }"
          v-for="m in categories"
          :key="m.id"
        >
          {{m.title}}
        </router-link>
      </div>      
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

import api from '../services/api'

export default {
  computed: {
    ...mapState([
      'categories'
    ]),
    activeId() {
      if (this.$route.name == 'Films') {
        return this.$route.params.id
      }
      return 0
    }
  },
  methods: {
    ...mapMutations([
      'setCategories'
    ]),
    getMenus() {
      api.getMenus().then(data => {
        this.setCategories(data)
      })
    }
  },
  created() {
    this.getMenus()
  }
}
</script>

<style lang="less" scoped>
.my-header {
  height: 60px;
  background-color: white;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  border-bottom: 1px solid #ccc;
  z-index: 50;

  .nav-menu {
    display: flex;
    align-items: center;
    height: 100%;
    float: left;
    margin-left: 48px;

    .menu-item {
      text-decoration: none;
      color: #000;
      font-size: 16px;
      margin-right: 45px;
      white-space: nowrap;

      &:hover {
        color: #666;
      }

      &.active {
        font-weight: 500;
        color: #666;
      }
    }
  }

  .logo {
    height: 100%;
    padding-top: 12px;
    float: left;

    img {
      height: 36px;
    }
  }
}
</style>
